module.exports = __webpack_public_path__ + "img/inbox-fill.d4c0b936.svg";